export const ProductSelectionType = Object.freeze({
    Storewide: "0",
    SpecificSelection: "1"
  });